module.exports = __webpack_public_path__ + "static/media/LGBTQ+ Hackers Meet-Up.8758b395.png";